export default __webpack_public_path__ + "static/media/ramdas.89566745.jpg";